
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PageBase, T4PricelistInfo } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';
import { CreatePricelistDialog } from '../../dialogs/CreatePricelistDialog/CreatePricelistDialog';
import moment from 'moment';
@Component({
  styleUrls: ['./ManagePricelists.css'],
  selector: 'ManagePricelists',
  templateUrl: './ManagePricelists.component.html',
})
export class ManagePricelistsComponent extends PageBase implements OnInit {
  public pricelists: T4PricelistInfo[];
  public childPricelists: T4PricelistInfo[];
  public stationPricelists: T4PricelistInfo[];
 
  @ViewChild("tblPricelists")
  private tblPricelists: T4DatatableWidget;
  @ViewChild("tblChildPricelists")
  private tblChildPricelists: T4DatatableWidget;
  @ViewChild("tblStationPricelists")
  private tblStationPricelists: T4DatatableWidget;
      

  public loading: boolean = false;

  constructor(el: ElementRef, private router: Router) {
      super(el, "Settings");
    }

  async ngOnInit() {
      await this.LoadPricelists();
  }

  private async LoadPricelists() {
    var token = this.UI.beginLoading("T4.Settings.ManagePricelists.msgLoading", "Loading pricelists", null);
    this.pricelists = await this.Api.get<T4PricelistInfo[]>("Settings/GetPricelists");

    if (this.Settings.isInAny(['GroupManager'])) {
      this.childPricelists = await this.Api.get<T4PricelistInfo[]>("Settings/GetChildPricelists");
      this.stationPricelists = await this.Api.get<T4PricelistInfo[]>("Settings/GetActiveStationPricelists");
    }

    if(this.tblPricelists) this.tblPricelists.update();
    if(this.tblChildPricelists) this.tblChildPricelists.update();
    if(this.tblStationPricelists) this.tblStationPricelists.update();
    this.UI.loaderCompleted(token);
  }

  public openPricelist(pl: T4PricelistInfo) {
    this.router.navigateByUrl("/Settings/Pricelist/" + pl.Id);
  }

  public openChildPricelist(pl: T4PricelistInfo) {
    this.router.navigateByUrl("/Settings/Pricelist/" + pl.Id + "/" + pl.RentalLocationGroupId);
  }

  public openStationPricelist(pl: T4PricelistInfo) {
    this.router.navigateByUrl("/Settings/Pricelist/" + pl.Id + "/" + pl.RentalLocationId);
  }

  public async deletePricelist(row: T4PricelistInfo, value: number) {
    if (await this.UI.confirm("T4.Settings.ManagePricelists.headConfirmRemove", "Confirm deletion", "T4.Settings.ManagePricelists.msgConfirmRemove", "Do you want to remove this pricelist? All prices will be lost.")) {
      await this.Api.delete("Settings/DeletePricelist", { id: row.Id, childId: value == 1 ? row.RentalLocationGroupId : value == 2 ? row.RentalLocationId : null })

      this.LoadPricelists();
    }
  }


  public async createPricelist(value: number) {
    await this.Dialog.open(CreatePricelistDialog, { data: { isChild: value } }).afterClosed().toPromise();
    this.LoadPricelists();
  }

  public async downloadPriceList() {
    var URL = "";
    if (this.Settings.clientSettings.RentalLocationGroupId && this.Settings.isInAny(["GroupManager"])) {
      URL = "https://t4api.brenderuprental.com/Documents/Tools/DownloadPriceListForGroup?groupId=" + this.Settings.clientSettings.RentalLocationGroupId;
    }
    else if (this.Settings.clientSettings.RentalLocationId && this.Settings.isInAny(["LocationManager", "Clerk"])) {
      URL = "https://t4api.brenderuprental.com/Documents/Tools/DownloadPriceList?locationId=" + this.Settings.clientSettings.RentalLocationId;
    }

    if (URL != "") {
      window.open(URL, "_blank");
    }
    else {
      await this.UI.alert("Turbo.General.FailedTtl", "Failed!", "Turbo.General.FailedMsg", "The action failed!");
    }
  }

  public async downloadAllPriceLists() {
    if (this.loading) return;

    this.loading = true;
    // Fetch all price lists
    const allPriceLists = await this.Api.get<T4PricelistInfo[]>("Settings/GetAllActivePricelists");

    let content = "";
    let allMappedObjects: any[] = [];

    // Iterate over all price lists
    allPriceLists.forEach(pricelist => {
      pricelist.Prices.forEach(price => {
        const interval = pricelist.Intervals.find(interval => interval.Id === price.IntervalId);
        if (!interval) return;

        // Create a new object for each price entry
        const mappedObject = {
          PriceListId: pricelist.Id,
          RentalLocationGroupName: pricelist.RentalLocationGroupName,
          RentalLocationName: pricelist.RentalLocationName,
          PriceListTitle: pricelist.Title,
          ObjectTypeId: price.ObjectTypeId,
          ObjectTypeName: price.ObjectType?.Title,
          Interval: interval.Interval,
          Price: price.Price,
          ValidFrom: pricelist.ValidFrom ? moment(pricelist.ValidFrom).format("YYYY-MM-DD") : "",
          ValidThrough: pricelist.ValidThrough ? moment(pricelist.ValidThrough).format("YYYY-MM-DD") : "",
        };

        allMappedObjects.push(mappedObject);
      });
    });

    // Collect headers dynamically
    const headers = Array.from(
      allMappedObjects.reduce((acc, obj) => {
        Object.keys(obj).forEach(key => acc.add(key));
        return acc;
      }, new Set<string>())
    );

    // Create CSV headers
    content += headers.join(";") + "\r\n";

    // Populate CSV rows
    allMappedObjects.forEach(obj => {
      content += headers.map(header => {
        let val = obj[header as keyof typeof obj];

        if (val === undefined || val === null) return "";

        if (val instanceof Date) return val.toISOString();
        if (moment.isMoment(val)) return val.format("YYYY-MM-DD HH:mm");
        if (typeof val === "string") return `"${val.replace(/\r?\n|\r/g, "").replace(/"/g, '""')}"`;
        if (typeof val === "number") return val.toString().replace(".", ",");

        return val.toString();
      }).join(";");

      content += "\r\n";
    });
    
    // Generate the CSV file
    const blob = new Blob([content], { type: "text/csv;charset=utf-8" });
    saveAs(blob, this.Settings.clientSettings.RentalLocationGroupId + "_All_PriceLists.csv");
    this.loading = false;
  }

}
